import AdvertisingSidebar from "./AdvertisingSidebar";
import PricingSidebar from "../../modules/pricingv2/Sidebar";
import Icon from "./Icon";
import promotionsPNG from "../../assets/images/icons/promotion-purple.svg";
import placementPNG from "../../assets/images/icons/placement-purple.svg";
import pricingPNG from "../../assets/images/icons/pricing-purple.svg";
import productPNG from "../../assets/images/icons/product-purple.svg";
import promotionsWhiteIcon from "../../assets/images/icons/promotion-w.png";
import placementWhiteIcon from "../../assets/images/icons/placement-w.png";
import pricingWhiteIcon from "../../assets/images/icons/pricing-w.png";
import productWhiteIcon from "../../assets/images/icons/product-w.png";
import { RiCoupon3Line } from "react-icons/ri";
import Section from "./Section";
import SidebarLink from "./SidebarLink";
import BISidebar from "./BISidebar";
import StaffSidebar from "./StaffSidebar";
import { FaRobot } from "react-icons/fa";
import useDashboardTheme, { PLACEMENT_SIDEBAR_COLOR } from "../../hooks/useDashboardTheme";
import { useProgramContext } from "../../components/custom/programs/ProgramContext";
import { useModuleEnabled } from "../../redux/selectors/modules";
import { useAppSelector } from "../../redux/hooks";
import { selectApplications } from "../../redux/selectors/applications";
import { FaMagnifyingGlassChart, FaPeopleGroup, FaVideo } from "react-icons/fa6";
import { GiStairsGoal } from "react-icons/gi";
import { css, cx } from "../../../styled-system/css";
import { useLocation } from "@tanstack/react-router";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SUPPORTED_VIDEO_GEN_MARKETPLACES } from "../../components/custom/video-generation/constants";

const PlacementIcon = () => <Icon path={placementPNG} />;

const PromotionsIcon = () => <Icon path={promotionsPNG} />;

const PricingIcon = () => <Icon path={pricingPNG} />;

const ProductIcon = () => <Icon path={productPNG} />;

const PlacementActiveIcon = () => <Icon path={placementWhiteIcon} />;

const PromotionsActiveIcon = () => <Icon path={promotionsWhiteIcon} />;

const ProductActiveIcon = () => <Icon path={productWhiteIcon} />;

const PricingActiveIcon = () => <Icon path={pricingWhiteIcon} />;

const AssetsIcon = () => <i className={cx("pe-7s-photo", css({ color: "#2e0054" }))} />;

const MerchantSidebar = () => {
  const { t } = useTranslation(["common"]);
  const user = useAppSelector((state) => state.user);
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const applications = useAppSelector((state) => selectApplications(state));

  const hasVideoGeneration = SUPPORTED_VIDEO_GEN_MARKETPLACES.includes(marketPlace) && channel === "amazon";
  // Subscribe to the whole location, not just pathname: useProgramContext below reads `?engine=` from window.location
  const { pathname } = useLocation();

  const isActive = (routeName) => {
    return pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const { section, sidebarColor } = useDashboardTheme();
  const { engine } = useProgramContext();
  const hasDSPModule = useModuleEnabled("DSP");
  const hasAMCModule = useModuleEnabled("AMC");

  return (
    <li
      className="user"
      style={{
        marginBottom: "3rem",
        marginTop: 0,
        paddingBottom: 0,
        borderBottom: "none",
        width: "100%",
        color: "#2e0054",
      }}
    >
      <ul className="nav">
        <SidebarLink
          to={"/user/agency/dashboard"}
          isActive={isActive("/user/agency/dashboard")}
          icon={<i className="fa fa-users" />}
          primarySidebarLink={true}
          isVisible={channel === "amazon"}
        >
          {t(($) => $.common.sidebar["Agency Dashboard"])}
        </SidebarLink>

        <SidebarLink
          to="/user/dashboard"
          isActive={`${isActive("/user/merchandising/product")} ${isActive("/user/merchandising/category")} ${pathname === "/user/dashboard" ? "active" : ""}`}
          icon={<i className="pe-7s-graph1"></i>}
          primarySidebarLink={true}
          isVisible={!(channel === "walmart" && user.organization_type === "vendor")}
        >
          {t(($) => $.common.sidebar.Dashboard)}
        </SidebarLink>

        <Section
          name={t(($) => $.common.sidebar.Placement)}
          Icon={PlacementIcon}
          ActiveIcon={PlacementActiveIcon}
          isActiveSection={section === "placement" || (isActive("/user/programs/") && engine === "bidding")}
          activeSection={section}
          activeColor={PLACEMENT_SIDEBAR_COLOR}
          isVisible={channel !== "shopify"}
        >
          <AdvertisingSidebar applications={applications} small />

          <SidebarLink
            to="/user/goals"
            isActive={isActive("/user/goals")}
            icon={
              <div className="fs-3 pt-1">
                <GiStairsGoal />
              </div>
            }
            small
            section={"product"}
          >
            <span
              style={{
                color: "#2e0054",
              }}
            >
              {t(($) => $.common.sidebar.Goals)}
            </span>
          </SidebarLink>

          <SidebarLink
            to="/user/dsp"
            isActive={isActive("/user/dsp")}
            icon={
              <div className="fs-3 pt-1">
                <FaRobot />
              </div>
            }
            small
            section={"product"}
            isVisible={hasDSPModule && channel === "amazon"}
          >
            <span
              style={{
                color: "#2e0054",
              }}
            >
              {t(($) => $.common.sidebar.DSP)}
            </span>
          </SidebarLink>
          <SidebarLink
            to="/user/amc/dashboard"
            isActive={isActive("/user/amc")}
            icon={<FaMagnifyingGlassChart className="mx-1" style={{ fontSize: "16px", marginTop: "7px" }} />}
            small
            section={"placement"}
            isVisible={hasAMCModule}
          >
            {t(($) => $.common.sidebar.AMC)}
          </SidebarLink>
          <SidebarLink
            to="/user/audience/dashboard"
            isActive={isActive("/user/audience")}
            icon={<FaPeopleGroup className="mx-1" style={{ fontSize: "16px", marginTop: "7px" }} />}
            small
            section={"placement"}
            isVisible={hasAMCModule}
          >
            {t(($) => $.common.sidebar["AMC Audiences"])}
          </SidebarLink>
          <SidebarLink
            to="/user/searchanalytics"
            isActive={isActive("/user/searchanalytics")}
            icon={<i className="pe-7s-search text-dark-purple" />}
            small
            section={"placement"}
            isVisible={channel === "amazon"}
          >
            {t(($) => $.common.sidebar["Search Analytics"])}
          </SidebarLink>

          <SidebarLink
            to={"/user/advertising/settings"}
            isActive={
              isActive("/user/advertising/settings") ||
              // Get program context => if ads, flag as active, do the same for pricing
              isActive("/user/programs")
            }
            icon={<i className="fa fa-cog" />}
            small
            section={"placement"}
          >
            {t(($) => $.common.sidebar.Configuration)}
          </SidebarLink>
        </Section>

        <Section
          name={t(($) => $.common.sidebar.Pricing)}
          Icon={PricingIcon}
          ActiveIcon={PricingActiveIcon}
          activeSection={section}
          activeColor={sidebarColor}
          isActiveSection={section === "pricing"}
          isVisible={channel !== "walmart"}
        >
          <PricingSidebar small />
        </Section>
        <Section
          name={t(($) => $.common.sidebar.Promotions)}
          Icon={PromotionsIcon}
          ActiveIcon={PromotionsActiveIcon}
          activeSection={section}
          activeColor={sidebarColor}
          isActiveSection={section === "promotions"}
          isVisible={channel === "amazon"}
          badge={t(($) => $.common.sidebar.BETA)}
        >
          <SidebarLink
            isActive={isActive("merchandising/promotions")}
            to="/user/merchandising/promotions"
            icon={<i className="pe-7s-ticket text-dark-purple" />}
            small
            section={"promotions"}
            isVisible={channel === "amazon"}
            badge={t(($) => $.common.sidebar.BETA)}
          >
            {t(($) => $.common.sidebar.Deals)}
          </SidebarLink>
          <SidebarLink
            isActive={isActive("merchandising/coupons")}
            to="/user/merchandising/coupons"
            icon={
              <span className="fs-3">
                <RiCoupon3Line />
              </span>
            }
            small
            section={"promotions"}
            isVisible={channel === "amazon"}
            badge={t(($) => $.common.sidebar.BETA)}
          >
            {t(($) => $.common.sidebar.Coupons)}
          </SidebarLink>
        </Section>

        <Section
          name={t(($) => $.common.sidebar.Product)}
          Icon={ProductIcon}
          ActiveIcon={ProductActiveIcon}
          activeSection={section}
          activeColor={sidebarColor}
          isActiveSection={section === "product"}
        >
          <SidebarLink
            isActive={isActive("content/quality") || isActive("content/seo")}
            to="/user/content/quality/org"
            icon={<i className="fa fa-road text-dark-purple" />}
            small
            section={"product"}
            isVisible={channel === "amazon"}
          >
            {t(($) => $.common.sidebar.Content)}
          </SidebarLink>

          <SidebarLink
            isActive={isActive("productlaunch")}
            to="/user/productlaunch"
            icon={<i className="pe-7s-rocket" />}
            small
            section={"product"}
            isVisible={channel === "amazon"}
          >
            {t(($) => $.common.sidebar["New Product Launch"])}
          </SidebarLink>

          <SidebarLink
            isActive={isActive("categorymanagement")}
            to="/user/categorymanagement"
            icon={
              <i
                className="pe-7s-keypad"
                style={{
                  color: "#2e0054",
                }}
              />
            }
            small
            section={"product"}
          >
            {t(($) => $.common.sidebar["Product & Categories"])}
          </SidebarLink>
        </Section>
        {hasVideoGeneration && (
          <Section
            name={t(($) => $.common.sidebar.Assets)}
            Icon={AssetsIcon}
            ActiveIcon={ProductActiveIcon}
            activeSection={section}
            activeColor={sidebarColor}
            isActiveSection={section === "assets"}
            badge={t(($) => $.common.sidebar.BETA)}
          >
            <SidebarLink
              isActive={isActive("videogen")}
              to="/user/videogen"
              icon={
                <FaVideo
                  className={cx(
                    "sidebar-mini",
                    css({
                      fontSize: "medium",
                      marginTop: "small",
                      paddingRight: "small",
                    }),
                  )}
                />
              }
              small
              section={"assets"}
            >
              {t(($) => $.common.sidebar["Video Generation"])}
              <Badge className={cx("badge-primary", css({ marginLeft: "0.5rem", fontSize: "9px" }))} pill>
                {t(($) => $.common.sidebar.BETA)}
              </Badge>
            </SidebarLink>
          </Section>
        )}
        <BISidebar
          title={t(($) => $.common.sidebar.Reports)}
          applications={applications}
          hideSearchAnalytics
          activeSection={section}
          activeColor={sidebarColor}
        />
        {user.is_staff && <StaffSidebar activeSection={section} />}
      </ul>
    </li>
  );
};

export default MerchantSidebar;
